import {Button, Form, Divider, Upload, Input, Modal, notification, Alert} from "antd";
import {DeleteOutlined, PictureOutlined} from "@ant-design/icons";
import Request from "../../utilis/api/Request";
import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../utilis/contexts/AuthContext";
import {ChangeSpecificationsValidation, Validation} from "../../utilis/tools/validation";
import Urls from "../../utilis/api/Urls";
import Texts from "../../utilis/defaults/Text";
import {RcFile, UploadFile, UploadProps} from "antd/es/upload/interface";
import {getBase64, getMergeImage} from "../../utilis/helpers/imageHelper";
import AuthenticatedForm from "./AuthenticatedForm";
import DefaultForm from "./DefaultForm";
import {ConvertPersianToEnglish} from "../../utilis/helpers/convertor";
import {DatePicker, JalaliLocaleListener} from "antd-jalali";
import locale from 'antd/es/date-picker/locale/fa_IR';
import CardImage from "../../card.png"
import UserVerification from "../UserVerification";
import VerifiedUser from "../../utilis/models/verifiedUser";
import ImageDrawer from "../../utilis/tools/ImageDrawer";
import ServiceResponseTime from "../../utilis/enums/ServiceResponseTime";
import ResponseMessageHandler from "../../utilis/helpers/ResponseMessage";
import Text from "../../utilis/defaults/Text";
import AbfaLogo from "../../images/logo.png"
import ConfirmInfoModal from "../modals/ConfirmInfoModal";

const ChangeSpecifications = () => {
    const authContext = useContext(AuthContext);
    // @ts-ignore
    const token = authContext.authenticated ? null : authContext.data.token;
    // @ts-ignore
    const [data, setData] = useState(authContext.authenticated ? authContext.data : authContext.data.data);
    const [authNationalPic, setAuthNationalPic] = useState('')
    const [isLoading, setLoading] = useState(false);
    const [nationalCartList, setNationalCartList] = useState<UploadFile[]>([]);
    const [birthCertificateList, setBirthCertificateList] = useState<UploadFile[]>([]);
    const [constructionDocumentList, setConstructionDocumentList] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [birthCertificateBase64, setBirthCertificateBase64] = useState('');
    const [nationalCartBase64, setNationalCartBase64] = useState('');
    const [constructionDocumentBase64, setConstructionDocumentBase64] = useState('');
    const [searchable, setSearchable] = useState(true);
    const [nationalCodeRequired, setNationalCodeRequired] = useState(true);
    const [verificationTry, setVerificationTry] = useState<boolean>(false);
    const [verifiedUsers, setVerifiedUsers] = useState<Array<VerifiedUser>>([]);
    const handleDeleteVerifiedUser = (index: number) => {
        setVerifiedUsers([
            ...verifiedUsers.slice(0, index),
            ...verifiedUsers.slice(index + 1)
        ]);
    }
    const handleVerificationTry = (hasTry: boolean) => {
        setVerificationTry(hasTry)
    }
    const handleVerifiedUsers = (VerifiedUsers: VerifiedUser) => {

        setVerifiedUsers([...verifiedUsers, VerifiedUsers])
    }

    useEffect(() => {
        if (verifiedUsers.length) {

            setNationalCodeRequired(false)
            ImageDrawer(CardImage, verifiedUsers).then(b64 => {


                setAuthNationalPic(b64)

            })
        } else {
            setAuthNationalPic('')

            setNationalCodeRequired(true)
        }
    }, [verifiedUsers])
    //merge-image
    useEffect(() => {
        getMergeImage(constructionDocumentList, (base64) => {

            setConstructionDocumentBase64(base64)
        })
    }, [constructionDocumentList]);
    useEffect(() => {
        getMergeImage(birthCertificateList, (base64) => {

            setBirthCertificateBase64(base64)
        })
    }, [birthCertificateList])
    useEffect(() => {
        getMergeImage(nationalCartList, (base64) => {

            setNationalCartBase64(base64)
        })
    }, [nationalCartList]);
    const [previewImage, setPreviewImage] = useState('');
    const birthCertificateProps: UploadProps = {
        fileList: birthCertificateList,
        onRemove: file => {
            const index = birthCertificateList.indexOf(file);
            const newFileList = birthCertificateList.slice();
            newFileList.splice(index, 1);
            setBirthCertificateList([]);
        },

        beforeUpload: (file: RcFile, files) => {

            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });
                return false

            } else {
                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;

                    setBirthCertificateList([newFile]);
                    return false
                })


            }
            return false


        },
    };
    const nationalCartProps: UploadProps = {
        fileList: nationalCartList,
        onRemove: file => {
            const index = nationalCartList.indexOf(file);
            const newFileList = nationalCartList.slice();
            newFileList.splice(index, 1);
            setNationalCartList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });
            } else {

                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;
                    console.log(newFile)
                    setNationalCartList([newFile]);
                    return false
                })
            }


            return false;
        },
    };
    const constructionDocumentProps: UploadProps = {
        fileList: constructionDocumentList,
        onRemove: file => {
            const index = constructionDocumentList.indexOf(file);
            const newFileList = constructionDocumentList.slice();
            newFileList.splice(index, 1);
            setConstructionDocumentList([]);
        },
        beforeUpload: (file: RcFile) => {
            if (file.size / 1000000 > 1) {
                notification['error']({
                    message: 'خطا',
                    description: 'فایل انتخابی باید کمتر از ۱ مگابایت باشد.',
                    duration: 120,
                });

            } else {
                getBase64(file).then((base64) => {
                    let newFile: UploadFile = file
                    newFile.thumbUrl = base64;
                    console.log(newFile)
                    setConstructionDocumentList([newFile]);
                    return false
                })
            }


            return false;
        },
    };
    const onPreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };
    const handleCancel = () => setPreviewOpen(false);
    const handlePrint = (text: string, name: string, traceNumber: string, address: string, orderType: string, mobile: string) => {
        // @ts-ignore

        // @ts-ignore
        var newWin = window.open('', '', 'height=650, width=650');
        // @ts-ignore
        newWin.document.write('');
        // @ts-ignore

        // @ts-ignore
        newWin.document.write(`
            <div style="margin-bottom: 4px;display: flex; justify-content: center;font-family:'iranSans';"><h3>اداره آب و فاضلاب مازندران</h3></div>
            <div style="border: 1px solid #5e5d5d;border-radius: 7px">
                        <p style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">${text}
        </p>
     
                <div style="direction:rtl;display: flex;justify-content: start;flex-wrap: wrap;font-family:'iranSans';">
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">نام و نام خانوادگی : ${name}</span>
                 <span style="padding: 10px;text-align: right;direction:rtl;border-radius: 4px;font-family:'iranSans'; ">کد رهگیری : ${traceNumber}</span>
                 <span style="padding: 10px;font-family:'iranSans';">نوع درخواست : ${orderType}</span>
                 <span style="padding: 10px;font-family:'iranSans';">موبایل : ${mobile}</span>
                 <span style="padding: 10px;font-family:'iranSans';">آدرس : ${address}</span>
        </div>
            </div>
                                   <div style="display: flex;justify-content: center;align-items: center;">
            <img style="width:250px;height: auto;margin-top: 50px; opacity: 80%" src="${AbfaLogo}" alt="">
</div>
        `);
        // @ts-ignore

        // @ts-ignore
        // @ts-ignore
        newWin.document.close();
        // @ts-ignore
        newWin.print();
    }
    const handleSubmit = (values: any) => {
        if (!verificationTry) {
            notification['error']({
                message: 'خطا',
                description: 'برای ثبت درخواست باید احراز هویت کدملی را انجام دهید',
                duration: 120
            });
            return;
        }
        if ((birthCertificateBase64 === "" || birthCertificateBase64 === null) && nationalCodeRequired) {
            notification['error']({
                message: 'خطا',
                description: 'به علت عدم احراز هویت از طریق کد ملی ، عکس  شناسنامه الزامی می باشد',
                duration: 120
            });
            return;
        }
        if ((nationalCartBase64 === "" || nationalCartBase64 === null) && nationalCodeRequired) {
            notification['error']({
                message: 'خطا',
                description: 'به علت عدم احراز هویت از طریق کد ملی ، عکس کارت ملی الزامی می باشد',
                duration: 120
            });
            return;
        }
        const body = {
            "Token": token,
            "Cellphone": authContext.authenticated ? authContext.user.cellphone : data.cellphone,
            "NationalCode": authContext.authenticated ? ConvertPersianToEnglish(values.nationalCode) : data.national_code,
            "PostalCode": authContext.authenticated ? ConvertPersianToEnglish(values.postalCode) : data.postal_code,
            "TelNumber": ConvertPersianToEnglish(values.tel),
            "MobileNumber": ConvertPersianToEnglish(values.mobile),
            "FileNumber": authContext.authenticated ? authContext.currentFileNumber : data.file_number,
            "FirstName": data.first_name,
            "LastName": data.last_name,
            "City": authContext.authenticated ? data.city_id : data.city,
            "Email": authContext.authenticated ? values.email : "",
            "Address": values.address ? values.address : data.address,
            "Description": authContext.authenticated ? values.description : data.description,
            "NewFirstName": authContext.authenticated ? values.firstName : data.first_name,
            "NewLastName": authContext.authenticated ? values.lastName : data.last_name,
            "ConstructionDocumentPic": constructionDocumentBase64,
            "BusinessNumber": values?.businessNumber,
            "NationalCardPic": nationalCodeRequired ? nationalCartBase64 : authNationalPic,
            "BirthCertificatePic": nationalCodeRequired ? birthCertificateBase64 : authNationalPic,
        };
        const modalData = {
            ...body,
            CityName: data.city_name,
        }
        Modal.confirm({
            direction: "rtl",
            title: 'آیا از صحت اطلاعات اطمینان دارید؟',
            content: <ConfirmInfoModal
                data={modalData}
                type={"ChangeSpecifications"}/>,
            onOk: () => handleRequest(body, values),
            closable: true,
            centered: true,
            okText: "تایید و ارسال",
            cancelText: "بستن",
            width: 800,
        })
    }
    const handleRequest = (body: any, values: any) => {
        setLoading(true)
        Request(Urls.ChangeSpecifications, body).then((response: any) => {
            const key = `open${Date.now()}`;

            notification['success']({
                message: response.message,
                description: ResponseMessageHandler(ServiceResponseTime.ChangeSpecifications, response.data.trace_number),
                duration: 120,
                key: key,
                btn: <Button type="primary" size="small" onClick={() => {
                    handlePrint(ResponseMessageHandler(ServiceResponseTime.ChangeSpecifications, response.data.trace_number), data.first_name + " " + data.last_name, response.data.trace_number, body.Address, Text.ChangeSpecifications, values.mobile);
                    notification.destroy()
                }}>
                    چاپ
                </Button>
            });
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })


    }
    const onFinishFailed = (error: any) => {

    }

    return <>
        <Form
            name="basic"
            className="w-full flex flex-col"
            layout='vertical'

            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            autoComplete="off" scrollToFirstError={true}
        >
            <AuthenticatedForm searchable={searchable} notDisable={['address']}
                               validationSchema={ChangeSpecificationsValidation} data={data}/>

            {searchable && <UserVerification verifiedUsers={verifiedUsers} handleVerificationTry={handleVerificationTry}
                                             data={data} handleVerifiedUsers={handleVerifiedUsers}/>}
            <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2" message="برای ثبت درخواست ابتدااحراز هویت از طریق کد ملی را انحام دهید."
                       type="error"/>
            </div>
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
                {verifiedUsers.map((verifiedUser: VerifiedUser, index) => {
                    return <div key={'modal-item' + index} className="p-3 mb-2 border rounded-xl bg-gray-50">


                        <div className="w-full grid gap-3 grid-cols-1 text-sm  md:grid-cols-2">
                            <div><strong>نام : </strong><span>{verifiedUser.firstName}</span></div>
                            <div><strong>نام خانوادگی : </strong><span>{verifiedUser.lastName}</span></div>
                            <div><strong>تاریخ تولد : </strong><span>{verifiedUser.birthDate}</span></div>
                            <div><strong>کد ملی : </strong><span>{verifiedUser.nationalCode}</span></div>
                            <div/>
                            <div className="flex justify-end items-center"><Button type="primary"
                                                                                   onClick={() => handleDeleteVerifiedUser(index)}
                                                                                   size="small" danger
                                                                                   icon={<DeleteOutlined/>}/></div>
                        </div>
                    </div>
                })}
            </div>
            <DefaultForm validationSchema={ChangeSpecificationsValidation} data={data}/>
            <Form.Item requiredMark="optional" label="کد اقتصادی / شناسه ملی" name="businessNumber"

                       rules={[Validation(ChangeSpecificationsValidation)]}>
                <Input size="large" type="tel"/>
            </Form.Item>
            <div className="mt-2 mb-2">
                <Alert className="mb-2 mt-2"
                       message="  کلیه تصاویر ارسالی باید در یکی از فرمت های jpg،tif،tiff،jpeg باشد." type="info"/>
            </div>
            {

                nationalCodeRequired && verificationTry && <> <Divider orientationMargin={3} orientation="center">
                    {Texts.birthCertificatePic + (nationalCodeRequired ? ' (الزامی)' : '(اختیاری)')}
                </Divider> <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                                   listType="picture-card" maxCount={1}  {...birthCertificateProps}>
                    <PictureOutlined/>
                </Upload></>
            }

            {nationalCodeRequired && verificationTry && <>
                <Divider orientationMargin={3} orientation="center">
                    {Texts.nationalCardPic + (nationalCodeRequired ? '(الزامی)' : ' (اختیاری) ')}
                </Divider>
                <Upload accept={"image/jpg,image/tif,image/tiff,image/png,image/jpeg"} onPreview={onPreview}
                        listType="picture-card" maxCount={1}  {...nationalCartProps}>
                    <PictureOutlined/>
                </Upload>
            </>}

            <Divider orientationMargin={3} orientation="center">
                {'سند نوع ملک '}
            </Divider>
            <Upload accept={"image/jpg,image/tif,image/tiff,image/png, image/jpeg"} onPreview={onPreview}
                    listType="picture-card" maxCount={1}  {...constructionDocumentProps}>
                <PictureOutlined/>
            </Upload>

            <Form.Item className="w-full mt-4">
                <Button loading={isLoading} size="large" type="primary" className="bg-primary w-full  md:w-[150px]"
                        htmlType="submit">
                    ثبت درخواست
                </Button>
            </Form.Item>

        </Form>
        <Modal open={previewOpen} title="تصویر" footer={null} onCancel={handleCancel}>
            <img alt="example" style={{width: '100%'}} src={previewImage}/>
        </Modal>
        {/* <Modal title="احراز هویت با کد ملی" footer={[]} open={NationalCodeModalIsOpen} onCancel={() => {
            setNationalCodeModalIsOpen(false)
        }}>
            <p>با احراز هویت نیاز به ارسال تصویر کارت ملی نمی باشد.</p>
            <Divider/>
            <Form

                name="basic"
                className="w-full mt-4 flex flex-col"
                layout='vertical'
                onFinish={NationalCodeInquiry}

                autoComplete="off" scrollToFirstError={true}
            >


                <Form.Item
                    label="نام "
                    name="firstName"

                    initialValue={data.first_name ? data.first_name : ''}
                >
                    <Input size="large"/>
                </Form.Item>
                <Form.Item
                    label="  نام خانوادگی"
                    name="lastName"
                    initialValue={data.last_name ? data.last_name : ''}
                >
                    <Input size="large"/>
                </Form.Item>
                <Form.Item
                    label="تاریخ تولد"
                    name="birthDay"

                >
                    <JalaliLocaleListener/>
                    <DatePicker format="YYYY/MM/DD" onChange={handleChangeDatePicker} className="w-full" size="large"
                                nextIcon={<></>} locale={locale}/>

                </Form.Item>


                <Form.Item className="w-full mt-5">
                    <Button size="large" type="default" onClick={() => {
                        setNationalCodeModalIsOpen(false)
                    }} className="ml-[1%] w-[48%]"
                            htmlType="button">
                        لغو
                    </Button>
                    <Button loading={isLoading} size="large" type="primary" className="bg-primary w-[48%] mr-[1%] "
                            htmlType="submit">
                        استعلام
                    </Button>
                </Form.Item>


            </Form>
        </Modal>*/}
    </>
}
export default ChangeSpecifications;